
import { useCallback, useEffect, useMemo, useState } from "react"
import { deteleBeaconsById, fetchBeacons } from "@/apiCalls/apiCalls"
import { Button } from "@/components/ui/button";
import { Beacons, BeaconsColumns } from "@/pages/beacons/BeaconColumns"
import Spinner from "../spinnner/Spinner"
import AddBeaconDrawer from "./AddBeaconDrawer"
import UpdateBeaconDrawer from "./UpdateBeaconDrawer"
import useAuth from "@/hooks/useAuth";
import { jwtDecode } from "jwt-decode"
import { BeaconDataTables } from "./BeaconDataTable"
import { useLocation, useNavigate } from "react-router-dom";
import useAxiosPrivate from "@/context/UseAxiosPrivate";
import { errorNotification, successNotification } from "@/utils/Notification";
import axios from "axios";
import ViewAuditLogsDrawer from "./ViewAuditLogsDrawerTree";
import ViewAuditLogsDrawerTable from "./ViewAuditLogsDrawerTable";
import DisableBeaconsDrawer from "./DisableBeaconsDrawer";

export default function BeaconFun() {
    const [data, setData] = useState<Beacons[]>([])
    const [loading, setLoading] = useState<boolean>(true)
    const [showAddBeaconDrawer, setshowAddBeaconDrawer] = useState(false)
    const [beaconsData, setBeaconsData] = useState<Beacons | undefined>(undefined)
    const [beaconsDataAudit, setBeaconsDataAudit] = useState<Beacons | undefined>(undefined)
    const [updateBeaconDrawer, setUpdateBeaconDrawer] = useState(false)
    const [viewAuditLogsDrawer, setViewAuditLogsDrawer] = useState(false)
    const [showDisableBeaconDrawer, setshowDisableBeaconDrawer] = useState(false)
    const { auth } = useAuth()
    let token: any = auth.accessToken
    const decoded: any = jwtDecode(token);
    let roles: string[] = decoded.UserInfo.roles
    const navigate = useNavigate()
    const location = useLocation()
    const axiosPrivate = useAxiosPrivate()



    const getBeacons = () => {
        setLoading(true)
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/beacons', {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: Beacons[]) => {
                if (isMounted) {
                    setData(data)
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            }).finally(() => {
                setLoading(false)
            })
        return () => {
            isMounted = false
            controller.abort()
        };
    };

    useEffect(() => {
        getBeacons()
    }, [])

    const getClientIPAndURL = async () => {
        try {

            const response = await axios.get('https://api.ipify.org?format=json');
            const clientIp = response.data.ip
            const currentUrl = window.location.href
            return { clientIp, currentUrl }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return { clientIp: 'Unknown', currentUrl: window.location.href }
        }
    }

    const deteleBeaconsById = (beaconId: any) => {
        let isMounted = true;
        const controller = new AbortController()
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivate.delete(`/api/v1/beacons/${beaconId}`, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then((data: any) => {
            if (isMounted) {
                successNotification(
                    "beacon successfully deleted",
                    "asset deleted",
                    'topRight'
                )

            }
            getBeacons()
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };


    const editFunctionCall = (beacons: Beacons) => {
        setBeaconsData(beacons)
        setUpdateBeaconDrawer(!updateBeaconDrawer)
    }
  
    const deleteFunctionCall = async (beacons: Beacons) => {
        deteleBeaconsById(beacons.id)
    }
    const viewAuditFunctionCall = async (beacons: Beacons) => {
        setBeaconsDataAudit(beacons)
        setViewAuditLogsDrawer(!viewAuditLogsDrawer)
    }

    const onDelete = useCallback(
        (beacons: Beacons) => deleteFunctionCall(beacons),
        []
    )

    const onEdit = useCallback(
        (beacons: Beacons) => editFunctionCall(beacons),
        []
    )
    const onViewAudits = useCallback(
        (beacons: Beacons) => viewAuditFunctionCall(beacons),
        []
    )

    const beaconsColumnsData = useMemo(() => BeaconsColumns({ onEdit, onDelete, roles,onViewAudits }), [])


    if (loading) {
        return <Spinner />
    }


    return (
        <main className='mx-3 mt-16 sm:ml-[300px] sm:mt-3'>
            <div className="flex flex-col sm:flex-row items-start justify-start space-y-2 sm:space-y-0 sm:space-x-4">
                {roles.includes('beacon-create') && (
                    <Button
                        variant='default'
                        onClick={() => setshowAddBeaconDrawer(!showAddBeaconDrawer)}
                    >
                        create Beacon
                    </Button>
                )}
                {roles.includes('beacon-delete') && (
                    <Button
                        variant='default'
                        onClick={() => setshowDisableBeaconDrawer(!showDisableBeaconDrawer)}
                    >
                        Disable Beacon(s)
                    </Button>
                )}
            </div>
            <BeaconDataTables columns={beaconsColumnsData} data={data} filterNameColumn="uuid" />
            {roles.includes('beacon-create') && (
                <AddBeaconDrawer
                    showAddBeaconDrawer={showAddBeaconDrawer}
                    setshowAddBeaconDrawer={setshowAddBeaconDrawer}
                    getBeacons={getBeacons}
                />
            )}

            {beaconsData && roles.includes('beacon-edit') && (
                <UpdateBeaconDrawer
                    updateBeaconDrawer={updateBeaconDrawer}
                    setUpdateBeaconDrawer={setUpdateBeaconDrawer}
                    beacons={beaconsData}
                    getBeacons={getBeacons}
                    setBeaconsData={setBeaconsData}
                />
            )}
            {roles.includes('beacon-delete') && (
                <DisableBeaconsDrawer
                    showDisableBeaconDrawer={showDisableBeaconDrawer}
                    setshowDisableBeaconDrawer={setshowDisableBeaconDrawer}
                    getBeacons={getBeacons}
                />
            )}
            {beaconsDataAudit  && (
                <ViewAuditLogsDrawerTable
                    viewAuditLogsDrawer={viewAuditLogsDrawer}
                    setViewAuditLogsDrawer={setViewAuditLogsDrawer}
                    beacons={beaconsDataAudit}
                    setBeaconsData={setBeaconsData}
                />
            )}
        </main>
    )
}